

export interface ICandidateTestVideoUploadPresignedUrlResponse {
    presignedThumbnailUpload: string
    presignedUploadUrl: string
    fileName: string
}


export interface ICandidateTestVideoUploadPresignedUrlVariables {
    questionIndex: number
}



export const candidateTestVideoUploadPresignedUrl = (variables: ICandidateTestVideoUploadPresignedUrlVariables) => {

    const data = JSON.stringify({
        query: `
        query CandidateTestVideoUploadPresignedUrl($questionIndex: Int!) {
            candidateTestVideoUploadPresignedUrl(questionIndex: $questionIndex) {
              presignedThumbnailUpload
              presignedUploadUrl
              fileName
            }
          }  
        `,
        variables: {
            "questionIndex": variables?.questionIndex ?? null
        }
    })

    return data
}